// extracted by mini-css-extract-plugin
export default {"coordinatorMobilbar":"CoordinatorMobilPageBar_coordinatorMobilbar__zlAWI"};